import React from 'react'
import { ButtonBase, Paper, Typography, Box } from '@mui/material'
import GroupIcon from '@mui/icons-material/Group';
import Favorite from '@mui/icons-material/Favorite';



function GroupListItem({groupName, numberMembers, onClick, numberHearts}) {
    return (
        <ButtonBase onClick={onClick} sx={{width: '100%', marginTop: '5px'}}>
            <Paper style={{width: '100%', padding: '20px', textAlign: 'left' }}>
                <Typography variant={'h6'} >{groupName}</Typography>
                <Box sx={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                    <GroupIcon />
                    <Typography variant={'body2'} sx={{marginLeft: '8px'}}>{numberMembers}</Typography>
                    <Favorite sx={{marginLeft: '25px'}} />
                    <Typography variant={'body2'} sx={{marginLeft: '8px'}}>{numberHearts}</Typography>
                </Box>
                {/* <Box sx={{display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: '5px'}}> */}
                    {/* <Typography variant={'body2'} fontWeight={'bold'}>Color Mode: </Typography>
                    <Typography variant={'body2'} sx={{marginLeft: '5px'}}>{colorMode}</Typography> */}
                {/* </Box>  */}
            </Paper>
        </ButtonBase>

        // <ButtonBase sx={{width: '100%', backgroundColor: 'yellow'}} onClick={onClick}>
        //     <Paper style={{ width: '100%', padding: '20px', textAlign: 'left' }}>
        //         <Typography variant={'h6'} >{name}</Typography>
        //         <Typography variant={'body2'}>{numberMembers} Members</Typography>
        //     </Paper>
        // </ButtonBase>
    )
}

export default GroupListItem